import { Vector } from 'excalibur';
import { InteractionType } from './interaction.models';

export type SFXEvents = GameEvents | PlayerEvents | MenuEvents | string;

export type LevelEventsPayload = {
  levelName: string;
  goTo: string;
  eventAction: string;
  interactionType: InteractionType;
  playerPosition: Vector;
  position: Vector;
  payload: unknown;
};

export enum GameEvents {
  START = 'start_game',
  QUIT = 'quit_game',
  SAVE = 'save_game',
  PAUSE = 'pause_game',
  RESUME = 'resume_game',
  START_DIALOG = 'start_dialog',
  CHANGE_SCENE = 'change_scene',
  CUTSCENE_START = 'cutscene_start',
  CUTSCENE_END = 'cutscene_end',
  ALERT = 'alert',
  FAILURE = 'failure',
}

export enum MenuEvents {
  CHANGE = 'menu_change',
  CHANGE_VALUE = 'menu_change_value',
  FORWARD = 'menu_forward',
  BACKWARD = 'menu_backward',
  FOCUS_BUTTON = 'menu_focus_button',
  SELECT = 'menu_select',
  CANCEL = 'menu_cancel',
}

export enum PlayerEvents {
  PLAYER_CREATED = 'player_created',
  ENTER_INTERACTABLE_ZONE = 'enter_interactable_zone',
  EXIT_INTERACTABLE_ZONE = 'leave_interactable_zone',
  PICK_ITEM = 'pick_item',
  TAKE_DAMAGE = 'player_take_damage',
  START_WALK = 'player_start_walk',
  UNLOCK_ITEM = 'unlock_item',
  JUMP = 'player_jump',
  FALL = 'player_fall',
  ATTACK = 'player_attack',
  DIE = 'player_die',
  STOP_WALK = 'player_stop_walk',
  INTERACT = 'player_interact',
}
